// @flow

export const customerTypes = Object.freeze({
  Employee: 'Employee',
  Student: 'Student',
});

export type CustomerType = $Values<typeof customerTypes>;
